module.exports = __webpack_public_path__ + "static/media/recently.56b53dbc.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/recently.jpg
// module id = 80
// module chunks = 0